module.exports = function (breakpointsService) {
    return {
        restrict: 'E',
        link($scope) {
            $scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };
        },
        template: require('./accessibility-nav-links-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/accessiblity/accessibility-nav-links-directive.js
 **/